import { Controller } from "stimulus";
import Swal from "sweetalert2";
import GuardianService from "../entrypoints/src/admin/services/guardian-service";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";
import { fillSelectedPerson } from "../entrypoints/src/admin/utilities/fill_person_to_form";
import StudentService from "../entrypoints/src/admin/services/student-service";

export default class extends Controller {
  connect() {
   this.$inputEmail = document.querySelector('[data-email-validation]');
   this.$accept = document.querySelector('[type="checkbox"].accept');
   if (!this.$inputEmail) return;

   this.$inputEmail.addEventListener('user-component:selected', (ev) => this.handleUser(ev));
  }

  handleUser(ev) {
    let user = ev.detail.user,
      accessToPortal = !!ev.detail.usePortal,
      $input = ev.target,
      $textMessage = $input.closest('.form-group').querySelector('.input-group ~ span');

    if (user.person.type === 'student' && !!user.enrollment) {
      return this.askToRedirect(user).then((result) => {
        if (!result.isConfirmed) {
          this.$inputEmail.value = this.$inputEmail.dataset.emailValidation;
          this.$inputEmail.dispatchEvent(new Event('blur'));
        } else {
          AjaxLoader.show();
          window.location = this.element.dataset.enrollmentPath.replace(':id', user.enrollment.id);
        }
      });
    }

    if (accessToPortal && (user.person.type === 'guardian_enroll' || !!user.person.guardian)) {
      if (this.element.dataset.persisted === 'true') {
        return this.askToMerge(user).then(async (result) => {
          if (!!result.isConfirmed) {
            let response = await StudentService.mergeGuardian(this.element.dataset.studentId, user.person.id);

            if (!!response) {
              Swal.fire({
                html: `Aluno atualizado com sucesso`,
                showClass: { backdrop: 'swal2-noanimation', popup: '', },
                hideClass: { popup: '' },
                customClass: {
                  cancelButton: 'btn btn-gray-primary',
                  confirmButton: 'btn btn-primary mr-3'
                },
                buttonsStyling: false,
                cancelButtonText: 'Fechar',
                confirmButtonText: 'Atualizar Página',
                onClose: () => { window.location.reload() }
              })
            }
          } else {
            this.$inputEmail.value = this.$inputEmail.dataset.emailValidation
            this.$accept.checked = false;
          }
        });
      }

      return this.askToConvert(user).then(async (result) => {
        if (result.isConfirmed) {
          let response = await GuardianService.toStudent(user.person.id);

          if (!!response) {
            let guardian = await GuardianService.find(user.person.id);
            fillSelectedPerson(guardian, this.element);
            $input.dataset.emailValidation = user.email;
          }
        } else {
          // toggle off the flag
          this.$accept.checked = false;
        }

        if (!$textMessage)
          return;

        $textMessage.innerHTML = '';
        $textMessage.setAttribute('class', '');
      });
    }
  }

  askToRedirect(user) {
    return Swal.fire({
			title: 'Atenção',
      type: 'warning',
			html: `
        Esse e-mail já está em uso pela matrícula <b>${user.person.name}</b>. <br><br>
        Gostaria de ser levado para lá?
      `,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: false,
			confirmButtonText: 'Redirecionar',
			cancelButtonText: 'Voltar para o e-mail anterior',
		});
  }

  askToConvert(user) {
    return Swal.fire({
			title: 'Atenção',
      type: 'warning',
			html: `
        Esse e-mail já está em uso pelo responsável
        <a class="text-secondary" target="_blank" href="${this.element.dataset.guardianPath.replace(':id', user.person.id)}">
          ${user.person.name}
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
          </svg>
        </a>. <br><br>
        Tem certeza de que gostaria de realizar a matrícula utilizando esse cadastro?
      `,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: false,
			confirmButtonText: 'Continuar',
			cancelButtonText: 'Cancelar',
		});
  }

  askToMerge(user) {
    return Swal.fire({
			title: 'Atenção',
      type: 'warning',
			html: `
        E-mail já está em uso pelo responsável
        <a class="text-secondary" target="_blank" href="${this.element.dataset.guardianPath.replace(':id', user.person.id)}">${user.person.name}</a>. <br><br>
        Gostaria de utilizá-lo como aluno também?
      `,
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: false,
			confirmButtonText: 'Continuar',
			cancelButtonText: 'Cancelar',
		});
  }
}
